const translations = {
  // Main Menu
  mainMenu: {
    title: "HARBOR",
    subtitle: "Bataille de Cartes Multijoueur",
    connected: "Connecté",
    connecting: "Connexion...",
    createRoom: "Créer une Salle",
    joinRoom: "Rejoindre une Salle",
    howToPlay: "Comment Jouer :",
    howToPlayItems: [
      "2+ joueurs",
      "Commencez avec 3 cartes : 2 pour la vie, 1 pour la défense",
      "Attaquez les joueurs ou changez leur défense",
      "Le Roi Rouge a la valeur 0",
      "Le dernier joueur debout gagne !"
    ]
  },

  // Create Room
  createRoom: {
    title: "Créer une Salle",
    yourName: "Votre Nom :",
    yourNamePlaceholder: "Entrez votre nom",
    creating: "Création...",
    createButton: "Créer une Salle",
    back: "Retour"
  },

  // Join Room
  joinRoom: {
    title: "Rejoindre une Salle",
    yourName: "Votre Nom :",
    yourNamePlaceholder: "Entrez votre nom",
    roomCode: "Code de la Salle :",
    roomCodePlaceholder: "XXXXXX",
    joining: "Connexion...",
    joinButton: "Rejoindre la Salle",
    back: "Retour"
  },

  // Errors
  errors: {
    enterName: "Veuillez entrer votre nom",
    enterRoomCode: "Veuillez entrer le code de la salle",
    anError: "Une erreur s'est produite"
  },

  // Room Lobby
  room: {
    title: "Lobby de la Salle",
    roomCodeLabel: "Code de la Salle :",
    copyLink: "📋 Copier le Lien d'Invitation",
    linkCopied: "✓ Lien Copié !",
    inviteHint: "Partagez ce lien pour inviter des joueurs directement !",
    playersLabel: "Joueurs",
    hostBadge: "Hôte",
    youBadge: "Vous",
    disconnected: "(déconnecté)",
    waitingForPlayers: "En attente de plus de joueurs... (minimum 2)",
    waitingForPlayersHost: "En attente de joueurs, ou ajoutez des IA ci-dessous pour commencer !",
    gameRules: "Règles du Jeu :",
    gameRulesItems: [
      "Chaque joueur reçoit 3 cartes au départ",
      "Choisissez 2 cartes pour les points de vie",
      "Choisissez 1 carte pour la défense",
      "Attaquez ou changez la défense à tour de rôle",
      "Les Rois Rouges ont la valeur 0",
      "Le dernier joueur en vie gagne !"
    ],
    startGame: "Démarrer la Partie",
    starting: "Démarrage...",
    waitingForHost: "En attente que l'hôte démarre la partie...",
    leaveRoom: "Quitter la Salle",
    gameStarting: "Démarrage de la Partie...",
    needTwoPlayers: "Besoin d'au moins 2 joueurs pour commencer. Ajoutez des IA ou attendez d'autres joueurs.",
    roomFull: "La salle est pleine (maximum 4 joueurs)",
    kickConfirm: "Êtes-vous sûr de vouloir expulser ce joueur ?",
    kickPlayerTitle: "Expulser le joueur",
    removeAITitle: "Retirer l'IA",
    youWereKicked: "Vous avez été expulsé de la salle par l'hôte",
    aiControlsTitle: "🤖 Joueurs IA",
    addAIPlayer: "+ Ajouter un Joueur IA",
    noAIPlayers: "Aucun joueur IA pour le moment",
    removeAIConfirm: "Retirer ce joueur IA ?"
  },

  // Game Board - Selection Phase
  selection: {
    title: "Sélectionnez Vos Cartes",
    instructions: "Choisissez 2 cartes pour la vie et 1 pour la défense",
    lifeCards: "Cartes de Vie",
    defenseCard: "Carte de Défense",
    confirmSelection: "Confirmer la Sélection",
    selectCardsError: "Veuillez sélectionner 2 cartes de vie et 1 carte de défense",
    selectCardsNotification: "Sélectionnez 2 cartes pour la vie et 1 pour la défense",
    waitingForPlayers: "En attente des autres joueurs..."
  },

  // Game Board - Playing Phase
  playing: {
    deck: "Deck",
    yourTurn: "VOTRE TOUR",
    opponents: "Adversaires",
    yourHand: "Votre Main",
    attack: "Attaquer",
    changeDefense: "Changer la Défense",
    cancel: "Annuler",
    selectPlayerToAttack: "Sélectionnez un joueur à attaquer",
    selectPlayerToChangeDefense: "Sélectionnez un joueur pour changer la défense",
    attacking: "Attaque...",
    changingDefense: "Changement de défense...",
    actionCancelled: "Action annulée"
  },

  // Game Board - Game Over Phase
  gameOver: {
    title: "PARTIE TERMINÉE",
    wins: "Gagne !",
    victory: "VICTOIRE !",
    finalStandings: "Classement Final",
    rank: "#",
    life: "Vie",
    returnToMenu: "Retour au Menu"
  },

  // Player Status
  playerStatus: {
    you: "(Vous)",
    turn: "TOUR",
    life: "Vie :",
    defense: "Défense :",
    defenseLabel: "Défense",
    lifeCards: "Cartes de Vie",
    eliminated: "ÉLIMINÉ",
    clickToSelect: "Cliquez pour sélectionner"
  },

  // Action Animation
  action: {
    cardDrawn: "Carte Tirée",
    hp: "PV"
  },

  // Common
  common: {
    waiting: "En attente du démarrage de la partie..."
  },

  // Messages
  messages: {
    title: "Messages",
    noMessages: "Aucun message pour le moment...",
    publicRecipient: "📢 Public",
    placeholder: "Écrivez un message...",
    send: "Envoyer",
    everyone: "Tout le monde",
    unknown: "Inconnu"
  },

  // Connection Status
  connection: {
    reconnecting: "Reconnexion... (Tentative {attempt})",
    disconnected: "Déconnecté du serveur",
    restoringSession: "Restauration de la session..."
  },

  // AI Indicator
  ai: {
    thinking: "{name} réfléchit"
  },

  // Player Hand
  hand: {
    selectCards: "Sélectionnez {count} carte{plural}",
    selectionCount: "({selected}/{total})"
  }
};

export default translations;
